var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomCollaspe',{staticClass:"filter-collapse status",attrs:{"collapse-id":'status-collapse',"collapse-header":'Offer'}},[_c('FilterOptionBtn',[_vm._v("Public offer")]),_c('FilterOptionBtn',[_vm._v("Exclusive offer")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }